import {SlaKpiTabsValuesMainHeader} from '../components'
import {TAB_TYPE_SORT_ORDER_MAP} from '../consts'
import {KpiTabValuesDto} from '../types'

import {
  SlaKpiTabsValuesTableContainer,
  SlaKpiTabsValuesTableContainerProps
} from './SlaKpiTabsValuesTableContainer'

type Props = {
  data: KpiTabValuesDto[]
  showAllHeader: boolean
  isDesktop: boolean
  cceKpiNameMap: Map<number, string>
} & Pick<
  SlaKpiTabsValuesTableContainerProps,
  'isCellEditable' | 'isCellCreatable' | 'isSubmitButtonVisible'
>

export const SlaKpiTabsValuesTablesContainer = ({
  data,
  showAllHeader,
  isDesktop,
  isCellEditable,
  isCellCreatable,
  isSubmitButtonVisible,
  cceKpiNameMap
}: Props) => {
  const categoriesCount = data.length
  const dataFieldsCount = data.reduce((total, current) => total + current.kpiDefinitions.length, 0)
  const sortedByTabType = data.sort(
    (a, b) => TAB_TYPE_SORT_ORDER_MAP[a.tabType] - TAB_TYPE_SORT_ORDER_MAP[b.tabType]
  )
  return (
    <>
      {showAllHeader && (
        <SlaKpiTabsValuesMainHeader
          categoriesCount={categoriesCount}
          dataFieldsCount={dataFieldsCount}
        />
      )}
      {sortedByTabType.map((kpiByTab) => {
        return (
          <SlaKpiTabsValuesTableContainer
            key={`tabvalues-table-${kpiByTab.tabType}`}
            data={kpiByTab}
            isCellCreatable={isCellCreatable}
            isSubmitButtonVisible={isSubmitButtonVisible}
            dataFieldsCount={dataFieldsCount}
            showDataFieldsCount={!showAllHeader}
            isDesktop={isDesktop}
            isCellEditable={isCellEditable}
            cceKpiNameMap={cceKpiNameMap}
          />
        )
      })}
    </>
  )
}
